module.exports = __webpack_public_path__ + "static/cartier-2ae9ace8eba81f15eab3210015a519e9.png";